module.exports = __webpack_public_path__ + "static/img/rank_244.85f50c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_244.png
// module id = 7YZp
// module chunks = 1